import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createBlog } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء مدونة جديدة
 */
export function useCreateBlog() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createBlogMutate,
        isPending,
    } = useMutation({
        mutationFn: createBlog,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
            navigate('/blog');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create blog");
        },
    });

    return {
        createBlogMutate,
        isPending,
    };
}
